import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import { useStateContext } from "../contexts/ContextProvider";
import { DateTime } from "luxon";
import {
  FaCcMastercard,
  FaCcVisa,
  FaCcDiscover,
  FaCcAmex,
  FaRegCreditCard,
  FaChevronRight,
  FaCcDinersClub,
} from "react-icons/fa6";
import { BsBank } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import { apiCreateBillingPortal } from "../services/apiService";
import { LoadingSpinner, ManageNotifications } from "../components";

const Account = () => {
  const { user, stripeSubscription, stripeConnectAccount, notifications } =
    useStateContext();
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  const handleSubscription = () => {
    if (
      stripeSubscription.type === "basic" ||
      stripeSubscription.type === "founder"
    ) {
      navigate("/account/subscription");
    } else {
      createBillingPortal();
    }
  };

  const createBillingPortal = async () => {
    setIsLoading(true);
    const response = await apiCreateBillingPortal();
    console.log(response.data.session.url);
    window.location.href = response.data.session.url;
  };

  console.log(notifications);

  return (
    <>
      <LoadingSpinner isLoading={isLoading} />
      <section id="header" className="w-screen">
        <Header />
      </section>
      {user.defaultView === "landlord" && (
        <>
          {/* <section 
                id="subscription" 
                className="fixed left-0 right-0 top-20 bottom-0 overflow-auto overscroll-none"> */}
          <section
            id="subscription"
            className="overflow-auto overscroll-none mt-20"
          >
            {/* <div className="flex justify-center text-3xl mt-10">Account</div> */}
            <div className="flex justify-start md:justify-center items-center text-2xl mt-10 pl-5">
              My Subscription
            </div>
            <div className="flex justify-center">
              <div className="w-[340px] sm:w-[500px] border-2 border-gray-300 rounded-xl mt-10 p-5">
                <div className="flex text-3xl capitalize">
                  <div>
                    {stripeSubscription.type === "founder"
                      ? "Premium"
                      : stripeSubscription.type}{" "}
                    Plan
                  </div>
                  {stripeSubscription.type === "basic" ||
                    (stripeSubscription.type === "founder" && (
                      <div className="ml-3">(Free)</div>
                    ))}
                </div>
                <div className="flex justify-start gap-x-2">
                  <div>Member Since:</div>
                  <div>
                    {DateTime.fromISO(user.createdAt).toFormat("MMMM yyyy")}
                  </div>
                </div>

                {stripeSubscription.type !== "basic" &&
                  stripeSubscription.type !== "founder" && (
                    <>
                      <div className="capitalized">
                        Billed:{" "}
                        {stripeSubscription.interval[0].toUpperCase() +
                          stripeSubscription.interval.slice(1)}
                        ly
                      </div>
                      <div className="flex items-center gap-x-1">
                        <div>
                          {stripeSubscription.cardBrand === "mastercard" && (
                            <FaCcMastercard className="text-2xl" />
                          )}
                          {stripeSubscription.cardBrand === "visa" && (
                            <FaCcVisa className="text-2xl" />
                          )}
                          {stripeSubscription.cardBrand === "discover" && (
                            <FaCcDiscover className="text-2xl" />
                          )}
                          {stripeSubscription.cardBrand === "amex" && (
                            <FaCcAmex className="text-2xl" />
                          )}
                          {stripeSubscription.cardBrand === "diners" && (
                            <FaCcDinersClub className="text-2xl" />
                          )}
                          {stripeSubscription.cardBrand !== "visa" &&
                            stripeSubscription.cardBrand !== "mastercard" &&
                            stripeSubscription.cardBrand !== "discover" &&
                            stripeSubscription.cardBrand !== "amex" &&
                            stripeSubscription.cardBrand !== "diners" && (
                              <FaRegCreditCard className="text-2xl" />
                            )}
                        </div>
                        <div className="pl-1 pt-3">**** **** ****</div>
                        <div> {stripeSubscription.last4}</div>
                        <div className="ml-2">Exp:</div>
                        <div>
                          {stripeSubscription.expMonth}/
                          {stripeSubscription.expYear}
                        </div>
                      </div>
                    </>
                  )}
                {stripeSubscription.type === "founder" && (
                  <div className="text-lg mt-3">
                    Thank you for being a Founder{" "}
                    <span className="text-3xl">👑</span>
                  </div>
                )}
                <div className="border-b-1 border-gray-300 mt-3"></div>
                <div
                  className="flex items-center justify-between hover:bg-gray-300 rounded-lg p-2 mt-2 cursor-pointer"
                  onClick={handleSubscription}
                >
                  {stripeSubscription.type === "basic" ? (
                    <div>Upgrade Subscription</div>
                  ) : (
                    <div>Manage Subscription</div>
                  )}
                  <FaChevronRight />
                </div>
              </div>
            </div>
          </section>
          <section id="banking">
            <div className="flex justify-start md:justify-center items-center text-2xl mt-10 pl-5">
              <div>Banking & Transfers</div>
            </div>
            <div className="flex justify-center">
              <div className="w-[340px] sm:w-[500px] border-2 border-gray-300 rounded-xl mt-10 p-5">
                {stripeConnectAccount &&
                stripeConnectAccount.payoutsEnabled &&
                stripeConnectAccount.externalAccountLast4 ? (
                  <div className="flex justify-center items-center text-2xl gap-x-2">
                    <BsBank />
                    <div className="pt-4">**** **** ****</div>
                    <div>{stripeConnectAccount.externalAccountLast4}</div>
                  </div>
                ) : (
                  <div className="flex justify-center">
                    Accept Electronic Payments
                  </div>
                )}
                <div className="border-b-1 border-gray-300 mt-3"></div>
                <div className="flex items-center justify-between ">
                  {!stripeConnectAccount && (
                    <div
                      className="flex justify-between items-center w-full hover:bg-gray-300 
                      rounded-lg p-2 mt-2 cursor-pointer"
                      onClick={() => {
                        navigate("/account/stripe-connect?ui=new");
                      }}
                    >
                      <div>Connect Bank Account</div>
                      <FaChevronRight />
                    </div>
                  )}
                  {stripeConnectAccount &&
                    !stripeConnectAccount.payoutsEnabled && (
                      <div
                        className="flex justify-between items-center w-full hover:bg-gray-300
                        rounded-lg p-2 mt-2 cursor-pointer"
                        onClick={() => {
                          navigate("/account/stripe-connect?ui=finish");
                        }}
                      >
                        <div>Finish Connecting Bank Account</div>
                        <FaChevronRight />
                      </div>
                    )}
                  {stripeConnectAccount &&
                    stripeConnectAccount.payoutsEnabled && (
                      <div className="w-full">
                        <div
                          className="flex justify-between items-center hover:bg-gray-300 
                          rounded-lg p-2 mt-2 cursor-pointer"
                          onClick={() => {
                            navigate("/account/stripe-connect?ui=balance");
                          }}
                        >
                          <div>My Balance</div>
                          <FaChevronRight />
                        </div>
                        <div
                          className="flex justify-between items-center hover:bg-gray-300 
                          rounded-lg p-2 mt-2 cursor-pointer"
                          onClick={() => {
                            navigate("/account/stripe-connect?ui=transfers");
                          }}
                        >
                          <div>Transfer History</div>
                          <FaChevronRight />
                        </div>
                        <div
                          className="flex justify-between items-center hover:bg-gray-300 
                          rounded-lg p-2 mt-2 cursor-pointer"
                          onClick={() => {
                            navigate("/account/stripe-connect?ui=documents");
                          }}
                        >
                          <div>Manage Documents</div>
                          <FaChevronRight />
                        </div>
                        <div
                          className="flex justify-between items-center hover:bg-gray-300 
                          rounded-lg p-2 mt-2 cursor-pointer"
                          onClick={() => {
                            navigate("/account/stripe-connect?ui=details");
                          }}
                        >
                          <div>Manage Banking Details</div>
                          <FaChevronRight />
                        </div>
                      </div>
                    )}
                </div>
              </div>
            </div>
          </section>
        </>
      )}
      <section id="notifications" className="mb-28">
        <div
          className={`flex justify-start md:justify-center items-center text-2xl pl-5 ${
            user.defaultView === "landlord" ? "mt-10" : "mt-20"
          }`}
        >
          <div className="mt-5">Notification Preferences</div>
        </div>
        <div className="flex justify-center w-full">
          <ManageNotifications />
        </div>
      </section>
    </>
  );
};

export default Account;
